import React from 'react';

import UserRoomsList from 'components/Messenger/content/UserRoomsList';

const SpecialPagesListL = props => (
  <div id="content">
    <UserRoomsList
      {...props}
      listReduceName="messengerModule.lists.messengerMyRoomsList"
    />
  </div>
);

export default SpecialPagesListL;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyMessages/RoomsList/RoomsList.js